import { render, staticRenderFns } from "./ChbEditPageFooter.vue?vue&type=template&id=a2853ff0&scoped=true"
import script from "./ChbEditPageFooter.vue?vue&type=script&lang=js"
export * from "./ChbEditPageFooter.vue?vue&type=script&lang=js"
import style0 from "./ChbEditPageFooter.vue?vue&type=style&index=0&id=a2853ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2853ff0",
  null
  
)

export default component.exports